<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                facilityForm: () => import('../forms/FacilityForm'),
                equipmentItemFileForm: () => import('../forms/EquipmentItemFileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Facility', value: 'facilityId', rules: [v => !!v || 'Facility is required'], isRequired: true, form: () => import('./FacilityForm'), apiMethod: 'Facilities', claim: 'Facilities' },
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'equipmentItemId', form: () => import('../forms/EquipmentItemFileForm') }
                ],
                apiMethod: 'EquipmentItems',
                formTitle: 'Equipment Item',
            }
        },
    };
</script>
